"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var Stack_1 = __importDefault(require("@mui/material/Stack"));
var final_form_1 = require("final-form");
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var Alerts_1 = __importDefault(require("atomicComponents/molecules/Alerts"));
var BlendButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/BlendButton"));
var Modal_1 = __importDefault(require("atomicComponents/organisms/Modal"));
var ModalContent_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalContent"));
var ModalFooter_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalFooter"));
var ModalHeader_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalHeader"));
var hooks_1 = require("containers/ConfirmationModal/hooks");
var Heading_1 = __importDefault(require("shared/components/Heading"));
var backend_1 = require("utils/backend");
var single_1 = require("utils/selectors/single");
var constants_1 = require("../../constants");
var InputInvoiceFields_1 = __importDefault(require("./InputInvoiceFields"));
var UploadCSV_1 = __importDefault(require("./UploadCSV"));
var utils_1 = require("./utils");
var getFilenameWarning = function (vendor, values, rechargeImport) {
    var _a;
    var csvFileName = values === null || values === void 0 ? void 0 : values.csvFile[0].name;
    if (vendor === 'Xero' && !csvFileName.includes(values.number)) {
        return 'There is a mismatch between the CSV file name and the invoice number. Should we submit anyway?';
    }
    if (((_a = rechargeImport === null || rechargeImport === void 0 ? void 0 : rechargeImport.uploadRequirements) === null || _a === void 0 ? void 0 : _a.fileName)
        && !csvFileName.startsWith(rechargeImport.uploadRequirements.fileName.replace(/\.csv/, ''))) {
        return 'The name of the CSV file seems to be different from what expected. Should we submit anyway?';
    }
    return undefined;
};
var UploadInvoice = function (_a) {
    var _b, _c;
    var open = _a.open, onClose = _a.onClose, setStep = _a.setStep, vendor = _a.vendor, rechargeImport = _a.rechargeImport, onClickLater = _a.onClickLater, onClickBack = _a.onClickBack, props = __rest(_a, ["open", "onClose", "setStep", "vendor", "rechargeImport", "onClickLater", "onClickBack"]);
    var rechargerCompany = (0, react_redux_1.useSelector)(single_1.selectMyRechargerCompany);
    var company = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var history = (0, react_router_dom_1.useHistory)();
    var confirm = (0, hooks_1.useConfirm)();
    var _d = __read((0, backend_1.useCall)('dataextract-uploadrechargedatacall', { companyId: rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.id }), 1), uploadData = _d[0];
    var onSubmit = function (_a) { return __awaiter(void 0, void 0, void 0, function () {
        var fileNameWarning, _b, _c, csvFileError, csvString, valuesToSend, invNumber, result;
        var _d, _e;
        var csvFile = _a.csvFile, values = __rest(_a, ["csvFile"]);
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    fileNameWarning = getFilenameWarning(vendor, __assign({ csvFile: csvFile }, values), rechargeImport);
                    _b = fileNameWarning;
                    if (!_b) return [3 /*break*/, 2];
                    return [4 /*yield*/, confirm('CSV filename mismatch', fileNameWarning, 'red', 'Submit anyway')];
                case 1:
                    _b = !(_f.sent());
                    _f.label = 2;
                case 2:
                    if (_b) {
                        return [2 /*return*/, undefined];
                    }
                    return [4 /*yield*/, (0, utils_1.validateCsvFile)(vendor)(csvFile)];
                case 3:
                    _c = _f.sent(), csvFileError = _c.error, csvString = _c.csvString;
                    if (csvFileError) {
                        return [2 /*return*/, (_d = {}, _d[final_form_1.FORM_ERROR] = 'Wrong CSV', _d.csvFile = csvFileError, _d)];
                    }
                    valuesToSend = {
                        dataSource: __assign(__assign({}, values), { id: rechargeImport === null || rechargeImport === void 0 ? void 0 : rechargeImport.id, date: values.date ? (0, end2end_1.getISODate)(values.date) : undefined, csvString: csvString, vendor: vendor }),
                    };
                    invNumber = (values === null || values === void 0 ? void 0 : values.number) || (rechargeImport === null || rechargeImport === void 0 ? void 0 : rechargeImport.number);
                    return [4 /*yield*/, uploadData((0, backend_1.parseParams)(valuesToSend))()];
                case 4:
                    result = _f.sent();
                    if (!!(result === null || result === void 0 ? void 0 : result.data.error)) return [3 /*break*/, 7];
                    return [4 /*yield*/, confirm('Charges successfully imported', '', 'green', 'OK!', true)];
                case 5:
                    _f.sent();
                    return [4 /*yield*/, (setStep === null || setStep === void 0 ? void 0 : setStep())];
                case 6:
                    _f.sent();
                    history.push("/recharges/charges/all".concat(invNumber ? "?search=".concat(invNumber) : ''));
                    _f.label = 7;
                case 7: return [2 /*return*/, (result === null || result === void 0 ? void 0 : result.data.error) && (_e = {}, _e[final_form_1.FORM_ERROR] = result.data.error, _e)];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)(Modal_1.default, __assign({ open: open, onClose: onClose }, props, { PaperProps: { sx: { maxWidth: 760 } } }, { children: [(0, jsx_runtime_1.jsx)(ModalHeader_1.default, { children: (0, jsx_runtime_1.jsxs)(Heading_1.default, __assign({ level: 3 }, { children: ["Upload your latest ", vendor, " invoice"] })) }), (0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ initialValues: { currency: (_c = (_b = rechargeImport === null || rechargeImport === void 0 ? void 0 : rechargeImport.currency) !== null && _b !== void 0 ? _b : rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.rechargesCurrency) !== null && _c !== void 0 ? _c : company === null || company === void 0 ? void 0 : company.baseCurrency }, onSubmit: onSubmit }, { children: function (_a) {
                    var handleSubmit = _a.handleSubmit, submitError = _a.submitError, submitting = _a.submitting;
                    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(ModalContent_1.default, { children: [(0, jsx_runtime_1.jsx)(UploadCSV_1.default, { vendor: vendor, expanded: !!rechargeImport || undefined, rechargeImport: rechargeImport }), !rechargeImport && (0, jsx_runtime_1.jsx)(InputInvoiceFields_1.default, { vendor: vendor })] }), (0, jsx_runtime_1.jsxs)(ModalFooter_1.default, { children: [(0, jsx_runtime_1.jsxs)(Stack_1.default, __assign({ direction: "row", alignItems: "center", justifyContent: "space-between", spacing: 2 }, { children: [submitError && (0, jsx_runtime_1.jsx)(Alerts_1.default, { severity: "error", message: constants_1.FILE_UPLOADER_ERROR_MAPPER[submitError], size: "small" }), (0, jsx_runtime_1.jsxs)(Stack_1.default, __assign({ direction: "row", spacing: 1 }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, __assign({ size: "large", color: "neutral", onClick: onClickLater !== null && onClickLater !== void 0 ? onClickLater : onClose }, { children: "I\u2019ll do this later" })), (0, jsx_runtime_1.jsx)(BlendButton_1.default, __assign({ size: "large", onClick: handleSubmit, isSending: submitting, type: "submit" }, { children: "Submit" }))] }))] })), onClickBack && (0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ size: "large", color: "neutral", onClick: onClickBack }, { children: "Go Back" }))] })] }));
                } }))] })));
};
exports.default = UploadInvoice;
